import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.4.2_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@playwright+test@1.59.1_@types+_fdba89b68390c914028a4ba3ab07e1ae/node_modules/next/dist/client/app-dir/link.js");
